import { UserLevelData, LevelData, LevelStatus } from '../Types';
// The level selected by default should be the latest that they are
// working on (latest datetime of level incomplete)
// or if complete, next latest incomplete level
const getHighestCompletedLevel = (userLevelData: UserLevelData[]) => {
  // Note lastLevelComplete is meaing "highest level complete"
  // We may want to add highestLevelComplete to replace lastLevelComplete
  // and lastLevelComplete can become "the level the user most recently completed"
  // which we could use to scroll to on the roadmap
  // Initialize to -1 so that level 0 completion can be detected (0 > -1 is true)
  let lastLevelComplete = -1;
  const userLevelStatuses: { [k: number]: string } = {};
  const userLevelTiersComplete: { [k: number]: number } = {};
  userLevelData.forEach((ul) => {
    if (ul.level) {
      userLevelStatuses[ul.level.level_number] = ul.status;
      // Only show last level as highest level complete
      if (
        (ul.status == LevelStatus.complete || !!ul.level_completed_at) &&
        ul.level.level_number > lastLevelComplete
      ) {
        lastLevelComplete = ul.level.level_number;
      }
      userLevelTiersComplete[ul.level.level_number] = ul.highest_tier_complete;
    }
  });
  return {
    lastLevelComplete: lastLevelComplete,
    userLevelStatuses: userLevelStatuses,
    userLevelTiersComplete: userLevelTiersComplete,
  };
};

const getUnitPctComplete = (highestCompletedLevel: number, levelData: LevelData[]) => {
  // Handle -1 (no levels complete) case
  if (highestCompletedLevel < 0) return 0;
  // Add 1 because highestCompletedLevel is 0-indexed (level 0 complete = 1 level complete)
  return (highestCompletedLevel + 1) / (levelData.length || 26);
};

export { getHighestCompletedLevel, getUnitPctComplete };
